import { Component, Inject, Input, OnInit } from '@angular/core';
import { Team } from './loading-indicator.interface';

@Component({
  selector: 'vm-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent implements OnInit {
  @Input() private team: Team = Team.CARE;

  /**
   * @deprecated Use config.assetsPath (VM_GLOBAL_CONFIG) instead. Check asset.pipe.ts
   */
  @Input() assetsPrefix?: string;

  loadingIndicatorPath: string;

  ngOnInit(): void {
    const whichImage = this.team === Team.SALES ? 'sales-s.gif' : 'care-s.gif';
    this.loadingIndicatorPath = `loading-indicators/${whichImage}`;
  }
}
